module.exports = __webpack_public_path__ + "img/icon-fail.24e11508.png";